(function (app) {

    app.config([
        "$stateProvider", function($stateProvider) {
            $stateProvider.state("Transaction.Application",
            {
                url: "/{transactionId}/Application",
                template: "<ui-view />",
                redirectTo: "Transaction.Application.Prefill",
                resolve: {
                    transaction: [
                        "transactionApi", "$transition$", function(transactionApi, $transition$) {
                            return transactionApi.get($transition$.params().transactionId); 
                        }
                    ]
                }
            });
        }
    ]);

})(window.app);